import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from "lodash";
import moment from 'moment';
import { Oval } from 'react-loader-spinner';

import { Dialog } from "primereact/dialog";
import { Tooltip } from 'primereact/tooltip';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Sidebar } from 'primereact/sidebar';

import "./index.css"

import HourGlassImg from "../../images/dispatchHourglass.png"
import DispatchImg from "../../images/dispatch.png"
import WorkInProgressImg from "../../images/work-in-progress.png"
import InvoicedImg from "../../images/invoice1.png"
import ForceClosurePendingImg from "../../images/forceClosurePending.png"
import ForceClosureImg from "../../images/forceClosure.png"
import CleanClosureImg from "../../images/cleanClosure.png"

import Menu from '../../helpers/Menu';
import Button from "../../helpers/Button"
import { CheckboxField } from "../../helpers";

import Loading from "../../common/Loading";
import ViewAdjustmentNote from '../../common/ViewAdjustmentNote';
import PMUserName from '../../common/PMUserName';
import PMCompanyName from '../../common/PMCompanyName';
import ButtonGroup from '../../common/ButtonGroup';
import CopyToClipboard from '../../common/CopyToClipboard';

import Search from "./Components/Search"
import CreateInvoice from './Components/CreateInvoice';
import CreateDeliveryChallan from './Components/CreateDeliveryChallan';
import UpdateTrackingDetailsAndPOD from './Components/UpdateTrackingDetailsAndPOD';
import ForceClose from './Components/ForceClose';

import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchMaterialBrands, fetchStates, fetchMaterialCategories, fetchCompanySupplyType } from "../../services/redux/reducers/commonThunk";
import { fetchBuyerPOs, updateSearchParams, setInitialLoad, setIsSearchVisible } from '../../services/redux/reducers/buyerPO/buyerPO';

import { getBuyerPOs } from '../../services/api/buyerPO';
import { getDispatchNoteItems } from '../../services/api/dispatchNoteItem';
import { getCompanyBillAddrs } from "../../services/api/companyBillAddr";
import { getCompanyBranchShipAddrs } from "../../services/api/companyBranchShipAddr";
import { getMaterialItemsDataByBuyerReqItemIds } from '../../services/api/buyerReqItem';
import { getBuyerInvoicesByBuyerPOIds } from '../../services/api/buyerInvoice';
import { getStockDocsByDocNos } from '../../services/api/stockDoc';
import { getDeliveryChallansByDispatchNoteIds } from '../../services/api/deliveryChallan';
import { getEwayBillByBuyerInvoiceIds } from '../../services/api/eWayBill';
import { getAdjustmentNotesByBuyerInvoiceIds } from '../../services/api/adjustmentNotes';
import { deleteDispatchNote } from '../../services/api/dispatchNote';
import { searchIncrementalReqLogs } from '../../services/api/incrementalReqLogs';

import { round, getCompanyShortName, numberConversion, getFullName, getUOMStr, getMaterialMasterDetailsTooltip, isMobile } from '../../utils';
import { getPMCompanyConfig } from '../../setup/pmCompanyConfig';
import { stockDocParser } from '../../parserFunctions'
import { DATE_FORMAT } from '../../constants';


const OpenPO = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [isCreateInvoiceModalVisible, setIsCreateInvoiceModalVisible] = useState(false)
    const [isCreateDeliveryChallanModalVisible, setIsCreateDeliveryChallanModalVisible] = useState(false)
    const [isCreateUpdateTrackingPODModalVisible, setIsCreateUpdateTrackingPODModalVisible] = useState(false)
    const [isForceCloseModalVisible, setIsForceCloseModalVisible] = useState(false)
    const [visibleViewAdjustmentNote, setVisibleViewAdjustmentNote] = useState(false)

    const [sellerPOs, setSellerPOs] = useState([])
    const [sellerPOItems, setSellerPOItems] = useState([])
    const [stocDocs, setStocDocs] = useState([])
    const [dispatchNotes, setDispatchNotes] = useState([])
    const [invoiceDispatchMap, setInvoiceDispatchMap] = useState([])
    const [buyerInvoices, setBuyerInvoices] = useState([])
    const [buyerInvoiceItems, setBuyerInvoiceItems] = useState([])
    const [deliveryChallans, setDeliveryChallans] = useState([])
    const [adjustmentNotes, setAdjustmentNotes] = useState([])
    const [materialDetails, setMaterialDetails] = useState([])
    const [selectedBuyerPOs, setSelectedBuyerPOs] = useState([])
    const [selectedForceClosingBuyerPOItems, setSelectedForceClosingBuyerPOItems] = useState([])
    const [selectedBuyerPODispatchNotes, setSelectedBuyerPODispatchNotes] = useState([])
    const [dispatchNoteItems, setDispatchNoteItems] = useState([])
    const [buyerCompanyBillAddrs, setBuyerCompanyBillAddrs] = useState([])
    const [buyerCompanyBranchShipAddrs, setBuyerCompanyBranchShipAddrs] = useState([])
    const [buyerCompanyPMBillAddrs, setBuyerCompanyPMBillAddrs] = useState([])
    const [expandedBuyerPORows, setExpandedBuyerPORows] = useState(null)
    const [eWayBills, setEWayBills] = useState([])
    const [selectedAdjustmentNotes, setSelectedAdjustmentNotes] = useState([])
    const [selectedBuyerInvoiceItems, setSelectedBuyerInvoiceItems] = useState([])
    const [isConfirmPreviewDialogVisible, setIsConfirmPreviewDialogVisible] = useState(false)
    const [previewBuyerInvoicesIds, setPreviewBuyerInvoicesIds] = useState([])
    const [incrementalReqLogs, setIncrementalReqLogs] = useState([])


    const statesList = useSelector((state) => state.common.states)
    const materialBrands = useSelector(state => state.common.materialBrands)
    const materialCategories = useSelector((state) => state.common.materialCategories)
    const companySupplyTypes = useSelector((state) => state.common.companySupplyType)

    const isPageLoading = useSelector(state => state.buyerPOData.loading)
    const searchParams = useSelector(state => state.buyerPOData.searchParams)
    const paginationParams = useSelector(state => state.buyerPOData.paginationParams)
    const buyerPOData = useSelector(state => state.buyerPOData.buyerPOData)
    const isInitialLoad = useSelector(state => state.buyerPOData.isInitialLoad)
    const isSearchVisible = useSelector(state => state.buyerPOData.isSearchVisible)
    const isSearchActive = useSelector(state => state.buyerPOData.isSearchActive)

    const userId = useSelector((state) => state.userDetails.userId)
    const userDetails = useSelector(state => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const dispatch = useDispatch()

    const actionMenu = useRef(null)

    const isMobileDevice = isMobile()

    useEffect(() => {
        getIntialLoadData()

        dispatch(fetchStates())
        dispatch(fetchMaterialBrands())
        dispatch(fetchMaterialCategories())
        dispatch(fetchCompanySupplyType())
    }, [])

    useEffect(() => {
        getBuyerInvoices()
        getStockDocs()
        getIncrementalReqLogs()
    }, [buyerPOData])

    useEffect(() => {
        getDeliveryChallans()
    }, [dispatchNotes])

    useEffect(() => {
        getEWayBills()
        getAdjustmentNotes()
    }, [buyerInvoices])

    const getIntialLoadData = () => {
        if (isInitialLoad) {
            let toDate = new Date()
            toDate.setHours(23, 59, 0, 0)
            toDate = toDate.toISOString()

            let fromDate = new Date()
            fromDate.setDate(fromDate.getDate() - 180)
            fromDate.setHours(0, 0, 0, 0)
            fromDate = fromDate.toISOString()

            const updatedSearchParams = {
                ...searchParams,
                fromDate: fromDate,
                toDate: toDate
            }

            dispatch(updateSearchParams(updatedSearchParams))
            dispatch(setInitialLoad(false))
        }
    }

    const getBuyerInvoices = async () => {
        let buyerPOIds = buyerPOData?.map(eachBuyerPO => eachBuyerPO.buyerPOId)
        if (buyerPOIds?.length > 0) {
            let data = { buyerPOIds: buyerPOIds }
            const response = await getBuyerInvoicesByBuyerPOIds(data)
            if (response.failure) {
                dispatch(raiseToast({ severity: 'error', summary: 'Buyer Invoice', detail: response.data.error, life: 3000 }))
            } else {
                setSellerPOs(response?.data?.sellerPO)
                setSellerPOItems(response?.data?.sellerPOItems)
                setDispatchNotes(response?.data?.dispatchNotes)
                setDispatchNoteItems(response?.data?.dispatchNoteItems)
                setInvoiceDispatchMap(response?.data?.invoiceDispatchMap)
                setBuyerInvoices(response?.data?.buyerInvoice)
                setBuyerInvoiceItems(response?.data?.buyerInvoiceItems)
                setMaterialDetails(response?.data?.materialDetails)
            }
        }
    }

    const getStockDocs = async () => {
        let docNos = buyerPOData?.map(eachBuyerPO => eachBuyerPO?.docNo)
        if (docNos?.length > 0) {
            const stocDocRes = await getStockDocsByDocNos({ docNos: docNos })
            //console.log("stocDocNos", stocDocRes)
            setStocDocs(stockDocParser(stocDocRes?.data))
        }
    }

    const getEWayBills = async () => {
        const buyerInvoiceIds = buyerInvoices?.map(eachBuyerInvoice => eachBuyerInvoice?.buyerInvoiceId)
        const ewayBillRes = await getEwayBillByBuyerInvoiceIds({ buyerInvoiceIds: buyerInvoiceIds })
        // console.log("ewayBillRes", ewayBillRes)
        if (ewayBillRes?.failure) {
            dispatch(raiseToast({ severity: 'error', summary: 'E-Way Bill', detail: ewayBillRes.data.error, life: 3000 }))
        } else {
            setEWayBills(ewayBillRes?.data)
        }
    }

    const getAdjustmentNotes = async () => {
        const buyerInvoiceIds = buyerInvoices?.map(eachBuyerInvoice => eachBuyerInvoice?.buyerInvoiceId)
        const adjustmentNoteRes = await getAdjustmentNotesByBuyerInvoiceIds({ buyerInvoiceIds: buyerInvoiceIds })
        // console.log("adjustmentNoteRes", adjustmentNoteRes)
        if (adjustmentNoteRes?.failure) {
            dispatch(raiseToast({ severity: 'error', summary: 'Adjustment Notes', detail: adjustmentNoteRes.data.error, life: 3000 }))
        } else {
            setAdjustmentNotes(adjustmentNoteRes?.data)
        }
    }

    const getDeliveryChallans = async () => {
        const relatedDispatchNoteIds = dispatchNotes?.map(eachDispatchNote => eachDispatchNote?.dispatchNoteId)
        if (relatedDispatchNoteIds?.length > 0) {
            const deliveryChallanRes = await getDeliveryChallansByDispatchNoteIds({ dispatchNoteIds: relatedDispatchNoteIds })
            // console.log("deliveryChallanRes", deliveryChallanRes)
            if (deliveryChallanRes?.failure) {
                dispatch(raiseToast({ severity: 'error', summary: 'Delivery Challan', detail: deliveryChallanRes.data.error, life: 3000 }))
            }

            setDeliveryChallans(deliveryChallanRes?.data?.deliveryChallans)
        }
    }

    const getIncrementalReqLogs = async () => {
        const clientPONums = []
        buyerPOData.map(eachBuyerPO => {
            if (eachBuyerPO.clientPONum){
                clientPONums.push(eachBuyerPO.clientPONum)
            }
        })

        const incrementalReqLogRes = await searchIncrementalReqLogs({clientPONums: clientPONums, paginator: false})
        if (incrementalReqLogRes.failure){
            return dispatch(raiseToast({ severity: 'error', summary: 'Incremental Req Logs', detail: incrementalReqLogRes.data.error, life: 3000 }))
        }

        setIncrementalReqLogs(incrementalReqLogRes.data)
    }

    const actionMenuItems = [
        {
            label: 'Preview Invoice' ,
            icon: '',
            command: async () => {
                await getSelectedBuyerPODispatchNotesForPreviewInvoice('CreateInvoice')
            },
            permissions: [38]
        },
        {
            label: 'Create Delivery Challan',
            icon: '',
            command: async () => {
                await getSelectedBuyerPODispatchNotes("CreateDeliveryChallan")
            },
            permissions: [37]
        },
        {
            label: 'Force Close',
            icon: '',
            command: async () => {
                await getSelectedForceClosingBuyerPOItems()
            },
            permissions: [108]
        },
        {
            label: 'Update Tracking and POD',
            icon: '',
            command: async () => {
                await getSelectedBuyerPODispatchNotes("UpdateTrackingAndPOD")
            }
        },
    ]

    const getSelectedBuyerPODispatchNotes = async (typeOfAction) => {
        setIsLoading(true)
        if (selectedBuyerPOs.length === 0) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'warn', summary: "Warning Message", detail: 'Please select buyerPOs', life: 3000 }))
        }
        else {

            const relatedBuyerCompanyId = selectedBuyerPOs[0]?.companyId
            const relatedBuyerCompanyBranchId = selectedBuyerPOs[0]?.branchId
            const relatedBuyerPMBillAddrId = selectedBuyerPOs[0]?.pmBillAddrId

            for (let i = 1; i < selectedBuyerPOs.length; i++) {
                if (selectedBuyerPOs[i]?.companyId !== relatedBuyerCompanyId) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'warn', detail: 'Please select same buyer company', life: 3000 }))
                }

                if (selectedBuyerPOs[i]?.branchId !== relatedBuyerCompanyBranchId) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'warn', detail: 'Please select same buyer company branch', life: 3000 }))
                }

                if (selectedBuyerPOs[i]?.pmBillAddrId !== relatedBuyerPMBillAddrId) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'warn', detail: "Please select same buyer po's with same pm bill address", life: 3000 }))
                }
            }

            let buyerPOIds = selectedBuyerPOs.map(eachBuyerPO => eachBuyerPO.buyerPOId)

            const getDispatchNoteItemsResponse = await getDispatchNoteItems({ buyerPOIds, statusId: 1, paginator: false })
            console.log("getDispatchNoteItems-response", getDispatchNoteItemsResponse)
            let dispatchNoteItems = getDispatchNoteItemsResponse.data
            if (getDispatchNoteItemsResponse.failure) {
                return dispatch(raiseToast({ severity: 'error', summary: getDispatchNoteItemsResponse.data.error, detail: 'Seller POs not fetched', life: 3000 }))
            } else {
                // let dispatchNotes = []
                // getDispatchNoteItemsResponse?.data?.map(eachDispatchNoteItem => {
                //     let relatedDispatchNote = dispatchNotes.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachDispatchNoteItem.dispatchNoteId)
                //     if (!relatedDispatchNote) {
                //         dispatchNotes.push(eachDispatchNoteItem.dispatchNotes)
                //     }
                // })
                // setSelectedBuyerPODispatchNotes(dispatchNotes)
            }

            setIsLoading(false)

            if (typeOfAction === "CreateInvoice") {

                let dispatchNotes = []
                dispatchNoteItems?.map(eachDispatchNoteItem => {
                    let relatedDispatchNote = dispatchNotes.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachDispatchNoteItem.dispatchNoteId)
                    if (!relatedDispatchNote) {
                        dispatchNotes.push(eachDispatchNoteItem.dispatchNotes)
                    }
                })

                let relatedInvoiceDispatchMap = []
                dispatchNotes?.map(eachDispatchNote => {
                    const relatedInvoiceDispatch = invoiceDispatchMap?.filter(eachInvoiceDispatchMap => eachInvoiceDispatchMap?.dispatchNoteId === eachDispatchNote?.dispatchNoteId && eachInvoiceDispatchMap.statusId === 1)
                    if (relatedInvoiceDispatch?.length > 0) {
                        relatedInvoiceDispatchMap = [...relatedInvoiceDispatchMap, ...relatedInvoiceDispatch]
                    }
                })

                let relatedPreviewBuyerInvoicesIds = []
                relatedInvoiceDispatchMap?.map(eachInvoiceDispatchMap => {
                    const relatedBuyerInvoice = buyerInvoices?.find(eachBuyerInvoice => eachBuyerInvoice?.buyerInvoiceId === eachInvoiceDispatchMap?.buyerInvoiceId && !eachBuyerInvoice.docNo)
                    if (relatedBuyerInvoice?.buyerInvoiceId) {
                        relatedPreviewBuyerInvoicesIds.push(relatedBuyerInvoice.buyerInvoiceId)
                    }
                })

                if (relatedPreviewBuyerInvoicesIds?.length > 0) {
                    setIsLoading(false)
                    setPreviewBuyerInvoicesIds(relatedPreviewBuyerInvoicesIds)
                    setIsConfirmPreviewDialogVisible(true)
                    return true
                    //return dispatch(raiseToast({ severity: 'error', detail: 'Preview Invoice was already generated. Please cancelled', life: 3000 }))
                }

                //let dispatchNoteIds = dispatchNoteItems.map(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteId)
                /*let relatedBuyerInvoiceIds = []

                relatedInvoiceDispatchMap?.map(eachInvoiceDispatchMap => {
                    const relatedBuyerInvoice = buyerInvoices?.find(eachBuyerInvoice => eachBuyerInvoice?.buyerInvoiceId === eachInvoiceDispatchMap?.buyerInvoiceId)
                    if (relatedBuyerInvoice) {
                        relatedBuyerInvoiceIds.push(relatedBuyerInvoice.buyerInvoiceId)
                    }
                })

                let buyerCreditNotes = []
                if(relatedBuyerInvoiceIds?.length){
                    buyerCreditNotes = await getBuyerCreditNotesByBuyerInvoiceIds({buyerInvoiceIds: relatedBuyerInvoiceIds})
                }

                let filteredDispatchNoteItems = []
                dispatchNotes.map(eachDispatchNote => {
                    const relatedInvoiceDispatchMap = invoiceDispatchMap?.filter(eachInvoiceDispatchMap => eachInvoiceDispatchMap?.dispatchNoteId === eachDispatchNote?.dispatchNoteId && eachInvoiceDispatchMap.statusId === 1)
                    if(relatedInvoiceDispatchMap.length > 0){
                        if(relatedInvoiceDispatchMap.length === 1){
                            const relatedInvoiceIds = relatedInvoiceDispatchMap.map(eachMap => eachMap.buyerInvoiceId)
                            const relatedReinvoicedBuyerCreditNote = buyerCreditNotes.find(eachCreditNote => eachCreditNote.adjustmentReasonId === 7 && eachCreditNote.buyerInvoiceId === relatedInvoiceDispatchMap[0].buyerInvoiceId)
                            const relatedDispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteId === eachDispatchNote.dispatchNoteId)
                            filteredDispatchNoteItems = [...relatedDispatchNoteItems, ...filteredDispatchNoteItems]
                        }
                    } else {
                        const relatedDispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteId === eachDispatchNote.dispatchNoteId)
                        filteredDispatchNoteItems = [...relatedDispatchNoteItems, ...filteredDispatchNoteItems]
                    }
                })*/

                dispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem?.dispatchNotes?.invoiceDispatchMaps.length === 0)

                //dispatchNoteItems = filteredDispatchNoteItems
                if (dispatchNoteItems?.length === 0) {
                    return dispatch(raiseToast({ severity: 'error', detail: 'No dispatch note found', life: 3000 }))
                } else {
                    setIsCreateInvoiceModalVisible(true)
                }
            }
            else if (typeOfAction === 'CreateDeliveryChallan') {
                dispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => !eachDispatchNoteItem?.dispatchNotes?.deliveryChallan)
                if (dispatchNoteItems?.length === 0) {
                    return dispatch(raiseToast({ severity: 'error', detail: 'No dispatch note found', life: 3000 }))
                } else {
                    setIsCreateDeliveryChallanModalVisible(true)
                }
            }
            else {
                dispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem?.dispatchNotes?.deliveryChallan)
                
                if (dispatchNoteItems?.length === 0) {
                    return dispatch(raiseToast({ severity: 'error', detail: 'No delivery challan found', life: 3000 }))
                } else {
                    setIsCreateUpdateTrackingPODModalVisible(true)
                }
            }

            let dispatchNotes = []
            dispatchNoteItems?.map(eachDispatchNoteItem => {
                let relatedDispatchNote = dispatchNotes.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachDispatchNoteItem.dispatchNoteId)
                if (!relatedDispatchNote) {
                    dispatchNotes.push({...eachDispatchNoteItem.dispatchNotes})
                }
            })
            dispatchNotes = dispatchNotes.filter(eachDispatchNote => eachDispatchNote.statusId === 1)
            setSelectedBuyerPODispatchNotes(dispatchNotes)

            let buyerReqItemsIds = dispatchNoteItems.map(eachDispatchNoteItem => eachDispatchNoteItem.buyerReqItemId)
            const materialMasterResponse = await getMaterialItemsDataByBuyerReqItemIds({ buyerReqItemsIds: buyerReqItemsIds })
            // console.log("materialMaster-response", materialMasterResponse)

            let materialMasterData = materialMasterResponse.data

            dispatchNoteItems.map(eachDispatchNoteItem => {
                let relatedMaterialItem = materialMasterData?.find(materialItem => materialItem.materialId === eachDispatchNoteItem.materialId)
                if (relatedMaterialItem) {
                    let relatedMaterialBrand = materialBrands.find(eachBrand => eachBrand.brandId === relatedMaterialItem.brandId)
                    if (relatedMaterialBrand) {
                        eachDispatchNoteItem.brandName = relatedMaterialBrand.brandName
                    }

                    const relatedCategory = materialCategories.find(eachIndustry => eachIndustry.categoryId === relatedMaterialItem.categoryId)
                    if (relatedCategory) {
                        eachDispatchNoteItem.categoryId = relatedCategory.categoryId
                        eachDispatchNoteItem.categoryName = relatedCategory.categoryName
                    }
                    eachDispatchNoteItem.UOM = relatedMaterialItem.UOM
                    eachDispatchNoteItem.companyProdName = relatedMaterialItem.companyProdName
                    eachDispatchNoteItem.companyProdSpec = relatedMaterialItem.companyProdSpec
                    eachDispatchNoteItem.productName = relatedMaterialItem.productName
                    eachDispatchNoteItem.variantName = relatedMaterialItem.variantName
                    eachDispatchNoteItem.productSpecification = relatedMaterialItem.productSpecification
                }
                return eachDispatchNoteItem
            })
            setDispatchNoteItems(dispatchNoteItems)
            
            let companyBillAddrIds = _.uniq(_.map(selectedBuyerPOs, 'billAddrId'))
            let companyBranchShipAddrIds = _.uniq(_.map(selectedBuyerPOs, 'shipAddrId'))

            let pmBillAddrIds = _.uniq(_.map(selectedBuyerPOs, 'pmBillAddrId'))
            companyBillAddrIds = [...companyBillAddrIds, ...pmBillAddrIds]

            getCompanyBillAddrsData(companyBillAddrIds, pmBillAddrIds)
            getCompanyBranchShipAddrsData(companyBranchShipAddrIds)
        }
    }

    const getSelectedBuyerPODispatchNotesForPreviewInvoice = async (typeOfAction) => {
        setIsLoading(true)

        if (selectedBuyerPOs.length === 0) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'warn', summary: "Warning Message", detail: 'Please select buyerPOs', life: 3000 }))
        }
        else {
            const relatedBuyerCompanyId = selectedBuyerPOs[0]?.companyId
            const relatedBuyerCompanyBranchId = selectedBuyerPOs[0]?.branchId
            const relatedBuyerPMBillAddrId = selectedBuyerPOs[0]?.pmBillAddrId
            const relatedBuyerCompanyTags = selectedBuyerPOs[0]?.["companies.tags"]

            for (let i = 1; i < selectedBuyerPOs.length; i++) {
                if (selectedBuyerPOs[i]?.companyId !== relatedBuyerCompanyId) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'warn', detail: 'Please select same buyer company', life: 3000 }))
                }

                if (selectedBuyerPOs[i]?.branchId !== relatedBuyerCompanyBranchId) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'warn', detail: 'Please select same buyer company branch', life: 3000 }))
                }

                if (selectedBuyerPOs[i]?.pmBillAddrId !== relatedBuyerPMBillAddrId) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'warn', detail: "Please select same buyer po's with same pm bill address", life: 3000 }))
                }
            }

            let buyerPOIds = selectedBuyerPOs.map(eachBuyerPO => eachBuyerPO.buyerPOId)
            const clientPONumbers = _.compact(selectedBuyerPOs.map(eachBuyerPO => eachBuyerPO.clientPONum))

            let params = {
                buyerPOIds: buyerPOIds,
                statusId: 1
            }

            if (relatedBuyerCompanyTags?.shouldEnforceDispatch && clientPONumbers.length){
                params.shouldEnforceDispatch = relatedBuyerCompanyTags.shouldEnforceDispatch
                params.buyerCompanyIds = [relatedBuyerCompanyId]
                params.branchIds = [selectedBuyerPOs[0].branchId]
                params.pmBranchIds = [selectedBuyerPOs[0].pmBranchId]
                params.clientPONumbers = clientPONumbers
            }

            const getDispatchNoteItemsResponse = await getDispatchNoteItems({...params, paginator: false}) //{ buyerPOIds, statusId: 1, paginator: false, shouldEnforceDispatch: relatedBuyerCompanyTags?.shouldEnforceDispatch}
            console.log("getDispatchNoteItems-response", getDispatchNoteItemsResponse)
            let dispatchNoteItems = getDispatchNoteItemsResponse.data
            if (getDispatchNoteItemsResponse.failure) {
                return dispatch(raiseToast({ severity: 'error', summary: getDispatchNoteItemsResponse.data.error, detail: 'Dispatch Note Items not fetched', life: 3000 }))
            } else {
                // let dispatchNotes = []
                // getDispatchNoteItemsResponse?.data?.map(eachDispatchNoteItem => {
                //     let relatedDispatchNote = dispatchNotes.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachDispatchNoteItem.dispatchNoteId)
                //     if (!relatedDispatchNote) {
                //         dispatchNotes.push(eachDispatchNoteItem.dispatchNotes)
                //     }
                // })
                // setSelectedBuyerPODispatchNotes(dispatchNotes)
            }


            const buyerPOIdsExcludingSelected = []
            dispatchNoteItems.map(eachDispatchNoteItem => {
                if (!buyerPOIds.includes(eachDispatchNoteItem.buyerPOId)){
                    buyerPOIdsExcludingSelected.push(eachDispatchNoteItem.buyerPOId)
                }
            })

            if (buyerPOIdsExcludingSelected.length){
                const buyerPORes = await getBuyerPOs({buyerPOIds: buyerPOIdsExcludingSelected})
                if (buyerPORes.failure) {
                    return dispatch(raiseToast({ severity: 'error', summary: buyerPORes.data.error, detail: 'Buyer POs not fetched', life: 3000 }))
                }     

                const updatedBuyerPOs = [...selectedBuyerPOs, ...buyerPORes.data.data]

                setSelectedBuyerPOs(updatedBuyerPOs)
            }

            setIsLoading(false)

            if (typeOfAction === "CreateInvoice") {

                let dispatchNotes = []
                dispatchNoteItems?.map(eachDispatchNoteItem => {
                    let relatedDispatchNote = dispatchNotes.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachDispatchNoteItem.dispatchNoteId)
                    if (!relatedDispatchNote) {
                        dispatchNotes.push(eachDispatchNoteItem.dispatchNotes)
                    }
                })

                let relatedInvoiceDispatchMap = []
                dispatchNotes?.map(eachDispatchNote => {
                    const relatedInvoiceDispatch = invoiceDispatchMap?.filter(eachInvoiceDispatchMap => eachInvoiceDispatchMap?.dispatchNoteId === eachDispatchNote?.dispatchNoteId && eachInvoiceDispatchMap.statusId === 1)
                    if (relatedInvoiceDispatch?.length > 0) {
                        relatedInvoiceDispatchMap = [...relatedInvoiceDispatchMap, ...relatedInvoiceDispatch]
                    }
                })

                let relatedPreviewBuyerInvoicesIds = []
                relatedInvoiceDispatchMap?.map(eachInvoiceDispatchMap => {
                    const relatedBuyerInvoice = buyerInvoices?.find(eachBuyerInvoice => eachBuyerInvoice?.buyerInvoiceId === eachInvoiceDispatchMap?.buyerInvoiceId && !eachBuyerInvoice.docNo)
                    if (relatedBuyerInvoice?.buyerInvoiceId) {
                        relatedPreviewBuyerInvoicesIds.push(relatedBuyerInvoice.buyerInvoiceId)
                    }
                })

                if (relatedPreviewBuyerInvoicesIds?.length > 0) {
                    setIsLoading(false)
                    setPreviewBuyerInvoicesIds(relatedPreviewBuyerInvoicesIds)
                    setIsConfirmPreviewDialogVisible(true)
                    return true
                    //return dispatch(raiseToast({ severity: 'error', detail: 'Preview Invoice was already generated. Please cancelled', life: 3000 }))
                }

                //let dispatchNoteIds = dispatchNoteItems.map(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteId)
                /*let relatedBuyerInvoiceIds = []

                relatedInvoiceDispatchMap?.map(eachInvoiceDispatchMap => {
                    const relatedBuyerInvoice = buyerInvoices?.find(eachBuyerInvoice => eachBuyerInvoice?.buyerInvoiceId === eachInvoiceDispatchMap?.buyerInvoiceId)
                    if (relatedBuyerInvoice) {
                        relatedBuyerInvoiceIds.push(relatedBuyerInvoice.buyerInvoiceId)
                    }
                })

                let buyerCreditNotes = []
                if(relatedBuyerInvoiceIds?.length){
                    buyerCreditNotes = await getBuyerCreditNotesByBuyerInvoiceIds({buyerInvoiceIds: relatedBuyerInvoiceIds})
                }

                let filteredDispatchNoteItems = []
                dispatchNotes.map(eachDispatchNote => {
                    const relatedInvoiceDispatchMap = invoiceDispatchMap?.filter(eachInvoiceDispatchMap => eachInvoiceDispatchMap?.dispatchNoteId === eachDispatchNote?.dispatchNoteId && eachInvoiceDispatchMap.statusId === 1)
                    if(relatedInvoiceDispatchMap.length > 0){
                        if(relatedInvoiceDispatchMap.length === 1){
                            const relatedInvoiceIds = relatedInvoiceDispatchMap.map(eachMap => eachMap.buyerInvoiceId)
                            const relatedReinvoicedBuyerCreditNote = buyerCreditNotes.find(eachCreditNote => eachCreditNote.adjustmentReasonId === 7 && eachCreditNote.buyerInvoiceId === relatedInvoiceDispatchMap[0].buyerInvoiceId)
                            const relatedDispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteId === eachDispatchNote.dispatchNoteId)
                            filteredDispatchNoteItems = [...relatedDispatchNoteItems, ...filteredDispatchNoteItems]
                        }
                    } else {
                        const relatedDispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.dispatchNoteId === eachDispatchNote.dispatchNoteId)
                        filteredDispatchNoteItems = [...relatedDispatchNoteItems, ...filteredDispatchNoteItems]
                    }
                })*/

                dispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem?.dispatchNotes?.invoiceDispatchMaps.length === 0)

                //dispatchNoteItems = filteredDispatchNoteItems
                if (dispatchNoteItems?.length === 0) {
                    return dispatch(raiseToast({ severity: 'error', detail: 'No dispatch note found', life: 3000 }))
                } 
                // else {
                //     setIsCreateInvoiceModalVisible(true)
                // }
            }
            else if (typeOfAction === 'CreateDeliveryChallan') {
                dispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => !eachDispatchNoteItem?.dispatchNotes?.deliveryChallan)
                if (dispatchNoteItems?.length === 0) {
                    return dispatch(raiseToast({ severity: 'error', detail: 'No dispatch note found', life: 3000 }))
                } 
                // else {
                //     setIsCreateDeliveryChallanModalVisible(true)
                // }
            }
            else {
                dispatchNoteItems = dispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem?.dispatchNotes?.deliveryChallan)
                if (dispatchNoteItems?.length === 0) {
                    return dispatch(raiseToast({ severity: 'error', detail: 'No delivery challan found', life: 3000 }))
                } 
                // else {
                //     setIsCreateUpdateTrackingPODModalVisible(true)
                // }
            }

            let dispatchNotes = []
            dispatchNoteItems?.map(eachDispatchNoteItem => {
                let relatedDispatchNote = dispatchNotes.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachDispatchNoteItem.dispatchNoteId)
                if (!relatedDispatchNote) {
                    dispatchNotes.push(eachDispatchNoteItem.dispatchNotes)
                }
            })
            dispatchNotes = dispatchNotes.filter(eachDispatchNote => eachDispatchNote.statusId === 1)
            setSelectedBuyerPODispatchNotes(dispatchNotes)

            let buyerReqItemsIds = dispatchNoteItems.map(eachDispatchNoteItem => eachDispatchNoteItem.buyerReqItemId)
            const materialMasterResponse = await getMaterialItemsDataByBuyerReqItemIds({ buyerReqItemsIds: buyerReqItemsIds })
            // console.log("materialMaster-response", materialMasterResponse)

            let materialMasterData = materialMasterResponse.data

            dispatchNoteItems.map(eachDispatchNoteItem => {
                let relatedMaterialItem = materialMasterData?.find(materialItem => materialItem.materialId === eachDispatchNoteItem.materialId)
                if (relatedMaterialItem) {
                    let relatedMaterialBrand = materialBrands.find(eachBrand => eachBrand.brandId === relatedMaterialItem.brandId)
                    if (relatedMaterialBrand) {
                        eachDispatchNoteItem.brandName = relatedMaterialBrand.brandName
                    }

                    const relatedCategory = materialCategories.find(eachIndustry => eachIndustry.categoryId === relatedMaterialItem.categoryId)
                    if (relatedCategory) {
                        eachDispatchNoteItem.categoryId = relatedCategory.categoryId
                        eachDispatchNoteItem.categoryName = relatedCategory.categoryName
                    }
                    eachDispatchNoteItem.UOM = relatedMaterialItem.UOM
                    eachDispatchNoteItem.companyProdName = relatedMaterialItem.companyProdName
                    eachDispatchNoteItem.companyProdSpec = relatedMaterialItem.companyProdSpec
                    eachDispatchNoteItem.productName = relatedMaterialItem.productName
                    eachDispatchNoteItem.variantName = relatedMaterialItem.variantName
                    eachDispatchNoteItem.productSpecification = relatedMaterialItem.productSpecification
                }
                return eachDispatchNoteItem
            })
            setDispatchNoteItems(dispatchNoteItems)

            let companyBillAddrIds = _.uniq(_.map(selectedBuyerPOs, 'billAddrId'))
            let companyBranchShipAddrIds = _.uniq(_.map(selectedBuyerPOs, 'shipAddrId'))

            let pmBillAddrIds = _.uniq(_.map(selectedBuyerPOs, 'pmBillAddrId'))
            companyBillAddrIds = [...companyBillAddrIds, ...pmBillAddrIds]

            getCompanyBillAddrsData(companyBillAddrIds, pmBillAddrIds)
            getCompanyBranchShipAddrsData(companyBranchShipAddrIds)

            if (typeOfAction === "CreateInvoice"){
                setIsCreateInvoiceModalVisible(true)
            }else if (typeOfAction === "CreateDeliveryChallan"){
                setIsCreateDeliveryChallanModalVisible(true)
            }else{
                setIsCreateUpdateTrackingPODModalVisible(true)
            }
        } 
    }

    const getSelectedForceClosingBuyerPOItems = async () => {
        if (selectedBuyerPOs.length === 0) {
            // setIsLoading(false)
            return dispatch(raiseToast({ severity: 'warn', summary: "Warning Message", detail: 'Please select buyerPO', life: 3000 }))
        } else if (selectedBuyerPOs?.length === 1) {
            const relatedIncrementalReqLogs = incrementalReqLogs.filter(eachIncrementalReqLog => eachIncrementalReqLog.clientPONum === selectedBuyerPOs[0].clientPONum)
            if (relatedIncrementalReqLogs.length){
                return dispatch(raiseToast({ severity: 'error', detail: 'Force Close Cannot be done for Incremental Requirement.', life: 3000 }))
            }

            const relatedBuyerPOItems = selectedBuyerPOs[0]?.buyerPOItems
            setSelectedForceClosingBuyerPOItems(relatedBuyerPOItems)
            setIsForceCloseModalVisible(true)
        } else {
            return dispatch(raiseToast({ severity: 'warn', detail: 'Force Close Can be done only for one Buyer PO at a time.', life: 3000 }))
        }
    }

    const getCompanyBillAddrsData = async (billAddrIds, pmBillAddrIds) => {

        const companyBillAddrResponse = await getCompanyBillAddrs({ billAddrIds, paginator: false })
        //console.log("companyBillAddrResponse===", companyBillAddrResponse)

        if (companyBillAddrResponse.failure) {
            return dispatch(raiseToast({ severity: 'error', summary: 'Error Message', detail: companyBillAddrResponse.data.error, life: 3000 }))
        } else {
            let companyBillAddrData = companyBillAddrResponse?.data?.data
            if (companyBillAddrData?.length > 0) {
                let relatedBuyerCompanyBillAddrs = []
                let relatedBuyerCompanyPMBillAddrs = []
                companyBillAddrData.map(billAddr => {
                    const relatedState = statesList.find(eachState => eachState.stateId === billAddr.stateId)
                    if (relatedState) {
                        billAddr.stateName = relatedState.stateName
                    }
                    if (pmBillAddrIds.includes(billAddr.billAddrId)) {
                        relatedBuyerCompanyPMBillAddrs.push(billAddr)
                    } else {
                        relatedBuyerCompanyBillAddrs.push(billAddr)
                    }
                    //return billAddr
                })

                setBuyerCompanyBillAddrs(relatedBuyerCompanyBillAddrs)
                setBuyerCompanyPMBillAddrs(relatedBuyerCompanyPMBillAddrs)
            }
        }
    }

    const getCompanyBranchShipAddrsData = async (shipAddrIds) => {
        const companyBranchShipAddrResponse = await getCompanyBranchShipAddrs({ shipAddrIds, paginator: false })
        // console.log("companyBranchShipAddrResponse===", companyBranchShipAddrResponse)

        if (companyBranchShipAddrResponse.failure) {
            return dispatch(raiseToast({ severity: 'error', summary: 'Error Message', detail: companyBranchShipAddrResponse.data.error, life: 3000 }))
        } else {
            let companyBranchShipAddrData = companyBranchShipAddrResponse?.data?.data
            if (companyBranchShipAddrData?.length > 0) {
                companyBranchShipAddrData.map(shipAddr => {
                    const relatedState = statesList.find(eachState => eachState.stateId === shipAddr.stateId)
                    if (relatedState) {
                        shipAddr.stateName = relatedState.stateName
                    }
                    return shipAddr
                })

                setBuyerCompanyBranchShipAddrs(companyBranchShipAddrData)
            }
        }
    }

    const handleSelectBuyerPOCheckbox = (event, row) => {
        let relatedBuyerPOs = []
        if (selectedBuyerPOs.includes(row)) {
            relatedBuyerPOs = selectedBuyerPOs.filter(eachBuyerPO => eachBuyerPO.buyerPOId === row.buyerPOId ? false : true)
        }
        else {
            relatedBuyerPOs = [...selectedBuyerPOs, row]
        }
        setSelectedBuyerPOs(relatedBuyerPOs)
    }

    const handleDeleteDispatchNote = async (dispatchNoteId) => {
        setIsLoading(true)

        const dispatchNoteRes = await deleteDispatchNote(dispatchNoteId)
        // console.log("dispatchNoteRes", dispatchNoteRes)

        if (dispatchNoteRes?.failure) {
            dispatch(raiseToast({ severity: 'error', detail: dispatchNoteRes.data.error, life: 3000 }))
        } else {
            const updatedSelectedBuyerPODispatchNotes = selectedBuyerPODispatchNotes.filter(obj => obj.dispatchNoteId !== dispatchNoteId)
            setSelectedBuyerPODispatchNotes(updatedSelectedBuyerPODispatchNotes)
            dispatch(raiseToast({ severity: 'success', detail: 'Dispatch note deleted successfully', life: 3000 }))
        }

        setIsLoading(false)
    }

    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
    }

    const selectAllBuyerPOs = () => {
        let relatedBuyerCompanyId = buyerPOData[0]?.companyId
        let relatedBuyerPO = buyerPOData.find(eachRow => eachRow?.companyId !== relatedBuyerCompanyId)
        if (relatedBuyerPO) {
            return dispatch(raiseToast({ severity: 'warn', detail: 'Please select unique buyer company', life: 3000 }))
        }
        let relatedBuyerPOs = []
        if (selectedBuyerPOs.length == buyerPOData.length) {
            relatedBuyerPOs = []
            handleHeaderExpand()
        }
        else {
            relatedBuyerPOs = buyerPOData
            setExpandedBuyerPORows(null)
        }
        setSelectedBuyerPOs(relatedBuyerPOs)
    }

    const getHeaderCheckbox = () => {
        return (
            <CheckboxField onChange={(e) => selectAllBuyerPOs(e)} checked={buyerPOData?.length && selectedBuyerPOs?.length === buyerPOData?.length} />
        )
    }

    const getBodyCheckbox = (data) => {
        let buyerCompanyId = ''
        if (data) {
            buyerCompanyId = data?.companyId
        }

        let isBuyerCompanySame = false
        if (selectedBuyerPOs.length > 0) {
            let selectedBuyerCompanyId = selectedBuyerPOs[0]?.companyId

            if (buyerCompanyId === selectedBuyerCompanyId) {
                isBuyerCompanySame = false
            } else {
                isBuyerCompanySame = true
            }
        }
        return (
            <div className='flex justify-content-center'>
                <CheckboxField checked={selectedBuyerPOs.includes(data)} onChange={(e) => handleSelectBuyerPOCheckbox(e, data)} disabled={isBuyerCompanySame} />
            </div>
        )
    }

    const getKAMBody = (row) => {
        const kamname = row["users.firstName"] + " " + row["users.lastName"] 
        return (
            <div className=""><PMUserName userName={kamname} userId={row.createdBy}/></div>
        )
    }

    const getDocNoBody = (row) => {
        let buyerName = getFullName(row["buyerCompanyUsers.firstName"], row["buyerCompanyUsers.lastName"])
        return (
            <>
                <div className='flex flex-row justify-content-center'>
                    <p className='doc-no' style={{ cursor: "pointer" }} onClick={() => window.open(`/buyerpo/${row?.buyerPOId}`, "_blank")}>{row.docNo}</p>
                    <CopyToClipboard text={row.docNo} />
                </div>
                <div className="date-string">{buyerName}</div>
                <div className="date-string">{moment(row?.createdAt).format(DATE_FORMAT)}</div>
            </>
        )
    }

    const getCompanyBody = (row) => {
        const companyShortName = getCompanyShortName(row["companies.companyName"])

        return (
            <>
                <PMCompanyName companyName={companyShortName} companyId={row.companyId}/>
                {
                    row["companies.gstinCode"] ? <div className="open-po-company-gstin">{row["companies.gstinCode"]}</div> : ""
                }
            </>
        )
    }

    const getStatusBody = (row) => {
        let buyerPOItems = row?.buyerPOItems
        let isDispatchNotYetStarted = true
        let isDispatchStarted = true
        let isInvoicingStarted = true
        let isInvoicingCompleted = true
        let hasForceClosurePending = true
        let hasForceClosure = true
        let hasCleanClosure = true
        console.log("stocDocs", stocDocs, buyerPOItems)
        if (buyerPOItems?.length > 0) {
            isDispatchNotYetStarted = buyerPOItems?.every(eachBuyerPOItem => {
                const relatedStocDoc = stocDocs?.find(eachStocDoc => eachStocDoc?.docNo == eachBuyerPOItem?.docNo && eachStocDoc?.materialId === eachBuyerPOItem?.materialId)
                let punchedQty = round(relatedStocDoc?.pendingQty + relatedStocDoc?.inProcessQty + relatedStocDoc?.invoicedQty + relatedStocDoc?.invoicePendingQty - relatedStocDoc?.CNDNQty)
                return punchedQty === relatedStocDoc?.pendingQty || !punchedQty
            })

            isDispatchStarted = buyerPOItems?.some(eachBuyerPOItem => {
                const relatedStocDoc = stocDocs?.find(eachStocDoc => eachStocDoc?.docNo == eachBuyerPOItem?.docNo && eachStocDoc?.materialId === eachBuyerPOItem?.materialId)
                let punchedQty = round(relatedStocDoc?.pendingQty + relatedStocDoc?.inProcessQty + relatedStocDoc?.invoicedQty + relatedStocDoc?.invoicePendingQty - relatedStocDoc?.CNDNQty)
                return relatedStocDoc?.invoicePendingQty !== 0 && punchedQty
            })

            isInvoicingStarted = buyerPOItems?.some(eachBuyerPOItem => {
                const relatedStocDoc = stocDocs?.find(eachStocDoc => eachStocDoc?.docNo == eachBuyerPOItem?.docNo && eachStocDoc?.materialId === eachBuyerPOItem?.materialId)
                let punchedQty = round(relatedStocDoc?.pendingQty + relatedStocDoc?.inProcessQty + relatedStocDoc?.invoicedQty + relatedStocDoc?.invoicePendingQty - relatedStocDoc?.CNDNQty)
                return relatedStocDoc?.invoicePendingQty === 0 && punchedQty !== relatedStocDoc?.pendingQty
            })

            isInvoicingCompleted = buyerPOItems?.every(eachBuyerPOItem => {
                const relatedStocDoc = stocDocs?.find(eachStocDoc => eachStocDoc?.docNo == eachBuyerPOItem?.docNo && eachStocDoc?.materialId === eachBuyerPOItem?.materialId)
                let punchedQty = round(relatedStocDoc?.pendingQty + relatedStocDoc?.inProcessQty + relatedStocDoc?.invoicedQty + relatedStocDoc?.invoicePendingQty - relatedStocDoc?.CNDNQty)
                return punchedQty === relatedStocDoc?.invoicedQty
            })

            hasForceClosurePending = buyerPOItems?.every(eachBuyerPOItem => {
                const relatedStocDoc = stocDocs?.find(eachStocDoc => eachStocDoc?.docNo == eachBuyerPOItem?.docNo && eachStocDoc?.materialId === eachBuyerPOItem?.materialId)
                let punchedQty = round(relatedStocDoc?.pendingQty + relatedStocDoc?.inProcessQty + relatedStocDoc?.invoicedQty + relatedStocDoc?.invoicePendingQty - relatedStocDoc?.CNDNQty)
                let relatedDispatchNoteItems = dispatchNoteItems?.filter(eachDispatchNoteItem => eachDispatchNoteItem?.buyerPOItemId === eachBuyerPOItem?.buyerPOItemId)
                let relatedDispatchNotes = []
                relatedDispatchNoteItems?.map(eachDispatchNoteItem => {
                    const relatedDispatchNote = dispatchNotes?.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachDispatchNoteItem?.dispatchNoteId)
                    if (relatedDispatchNote?.dispatchNoteId) {
                        relatedDispatchNotes.push(relatedDispatchNote)
                    }
                })
                let relatedDeliveryChallans = []
                relatedDispatchNotes?.map(eachDispatchNote => {
                    const relatedDeliveryChallan = deliveryChallans?.find(eachDeliveryChallan => eachDeliveryChallan?.dispatchNoteId === eachDispatchNote?.dispatchNoteId)
                    if (relatedDeliveryChallan?.deliveryChallanId) {
                        relatedDeliveryChallans.push(relatedDeliveryChallan)
                    }
                })
                let allPODsUploaded = false
                allPODsUploaded = relatedDeliveryChallans?.every(eachDeliveryChallan => eachDeliveryChallan?.docProof)
                return (punchedQty !== relatedStocDoc?.invoicedQty && !allPODsUploaded) || eachBuyerPOItem?.statusId === 7
            })

            hasForceClosure = buyerPOItems?.every(eachBuyerPOItem => {
                const relatedStocDoc = stocDocs?.find(eachStocDoc => eachStocDoc?.docNo == eachBuyerPOItem?.docNo && eachStocDoc?.materialId === eachBuyerPOItem?.materialId)
                let punchedQty = round(relatedStocDoc?.pendingQty + relatedStocDoc?.inProcessQty + relatedStocDoc?.invoicedQty + relatedStocDoc?.invoicePendingQty - relatedStocDoc?.CNDNQty)
                let relatedDispatchNoteItems = dispatchNoteItems?.filter(eachDispatchNoteItem => eachDispatchNoteItem?.buyerPOItemId === eachBuyerPOItem?.buyerPOItemId)
                let relatedDispatchNotes = []
                relatedDispatchNoteItems?.map(eachDispatchNoteItem => {
                    const relatedDispatchNote = dispatchNotes?.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachDispatchNoteItem?.dispatchNoteId)
                    if (relatedDispatchNote?.dispatchNoteId) {
                        relatedDispatchNotes.push(relatedDispatchNote)
                    }
                })
                let relatedDeliveryChallans = []
                relatedDispatchNotes?.map(eachDispatchNote => {
                    const relatedDeliveryChallan = deliveryChallans?.find(eachDeliveryChallan => eachDeliveryChallan?.dispatchNoteId === eachDispatchNote?.dispatchNoteId)
                    if (relatedDeliveryChallan?.deliveryChallanId) {
                        relatedDeliveryChallans.push(relatedDeliveryChallan)
                    }
                })
                let allPODsUploaded = false
                if (relatedDeliveryChallans?.length) {
                    allPODsUploaded = relatedDeliveryChallans?.every(eachDeliveryChallan => eachDeliveryChallan?.docProof)
                }
                return (punchedQty !== relatedStocDoc?.invoicedQty && allPODsUploaded && relatedStocDoc?.pendingQty === 0) || eachBuyerPOItem?.statusId === 4
            })

            hasCleanClosure = buyerPOItems?.every(eachBuyerPOItem => {
                const relatedStocDoc = stocDocs?.find(eachStocDoc => eachStocDoc?.docNo == eachBuyerPOItem?.docNo && eachStocDoc?.materialId === eachBuyerPOItem?.materialId)
                let punchedQty = round(relatedStocDoc?.pendingQty + relatedStocDoc?.inProcessQty + relatedStocDoc?.invoicedQty + relatedStocDoc?.invoicePendingQty - relatedStocDoc?.CNDNQty)
                let relatedDispatchNoteItems = dispatchNoteItems?.filter(eachDispatchNoteItem => eachDispatchNoteItem?.buyerPOItemId === eachBuyerPOItem?.buyerPOItemId)
                let relatedDispatchNotes = []
                relatedDispatchNoteItems?.map(eachDispatchNoteItem => {
                    const relatedDispatchNote = dispatchNotes?.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachDispatchNoteItem?.dispatchNoteId)
                    if (relatedDispatchNote?.dispatchNoteId) {
                        relatedDispatchNotes.push(relatedDispatchNote)
                    }
                })
                let relatedDeliveryChallans = []
                relatedDispatchNotes?.map(eachDispatchNote => {
                    const relatedDeliveryChallan = deliveryChallans?.find(eachDeliveryChallan => eachDeliveryChallan?.dispatchNoteId === eachDispatchNote?.dispatchNoteId)
                    if (relatedDeliveryChallan?.deliveryChallanId) {
                        relatedDeliveryChallans.push(relatedDeliveryChallan)
                    }
                })
                let allPODsUploaded = false
                if (relatedDeliveryChallans?.length) {
                    allPODsUploaded = relatedDeliveryChallans?.every(eachDeliveryChallan => eachDeliveryChallan?.docProof)
                }
                return punchedQty === relatedStocDoc?.invoicedQty && relatedStocDoc?.pendingQty === 0 && allPODsUploaded && relatedStocDoc?.invoicedQty
            })
        }

        // console.log("status", isDispatchNotYetStarted, isDispatchStarted, isInvoicingStarted, isInvoicingCompleted, hasForceClosurePending, hasForceClosure, hasCleanClosure)
        let imageUrl = ""
        if (isDispatchNotYetStarted) {
            imageUrl = HourGlassImg
        }
        if (!isDispatchNotYetStarted && isDispatchStarted) {
            imageUrl = DispatchImg
        }
        if (isInvoicingStarted) {
            imageUrl = WorkInProgressImg
        }
        if (isInvoicingStarted && isInvoicingCompleted) {
            imageUrl = InvoicedImg
        }
        if (hasForceClosurePending && isInvoicingStarted) {
            imageUrl = ForceClosurePendingImg
        }
        if (hasForceClosure) {
            imageUrl = ForceClosureImg
        }
        if (hasCleanClosure && isInvoicingCompleted) {
            imageUrl = CleanClosureImg
        }

        return (
            <div className='text-center'>
                {
                    imageUrl === "" ? <div className='flex justify-content-center align-items-center'><Oval height={15} /></div> :
                        <img src={imageUrl} style={{ height: 28 }} />
                }
            </div>
        )
    }


    const getPONumberBody = (row) => {
        return (
            <div className="">
                {row.clientPONum ? row.clientPONum : "-"}
                {row.clientPONum ? <CopyToClipboard text={row.clientPONum} /> : ""}
            </div>
        )
    }

    const getSellerPODocNoBody = (buyerPOItem) => {
        const relatedSellerPOItems = sellerPOItems?.filter(eachSellerPOItem => eachSellerPOItem?.buyerPOItemId === buyerPOItem?.buyerPOItemId && eachSellerPOItem?.statusId === 3)
        return (
            <>
                {
                    relatedSellerPOItems?.map(eachSellerPOItem => (
                        <>
                            <Link to={`/sellerpo/${eachSellerPOItem.sellerPOId}`} style={{ textDecoration: "none", cursor: "pointer" }} target='_blank'>{eachSellerPOItem.docNo}</Link>
                            <CopyToClipboard text={eachSellerPOItem.docNo} />
                        </>
                    ))
                }
            </>
        )
    }

    const getMaterialIdBody = (row) => {
        const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === row?.materialId)
        const relatedMaterialBrand = materialBrands?.find(eachMaterialBrand => eachMaterialBrand?.brandId === relatedMaterial?.brandId)
        return (
            <>
                <div className={`custom-tool-tip-${row?.materialId}`}>{row?.materialId}</div>
                <Tooltip target={`.custom-tool-tip-${row?.materialId}`} position="top" autoHide>
                    {getMaterialMasterDetailsTooltip({ brandName: relatedMaterialBrand?.brandName, productName: relatedMaterial?.productName, productSpecification: relatedMaterial?.productSpecification, variantName: relatedMaterial?.variantName, renderHTML: true, UOM: relatedMaterial?.UOM, UOMValue: relatedMaterial?.UOMValue })}
                </Tooltip>
            </>
        )
    }

    const getProductNameBody = (row) => {
        const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === row?.materialId)
        return (
            <div>{relatedMaterial?.companyProdName ? relatedMaterial?.companyProdName : relatedMaterial?.productName}</div>
        )
    }

    const getProductSpecificationBody = (row) => {
        const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === row?.materialId)
        return (
            <div className='text-left'>{relatedMaterial?.companyProdSpec ? relatedMaterial?.companyProdSpec : relatedMaterial?.productSpecification} - {getUOMStr(relatedMaterial?.UOM, relatedMaterial?.UOMValue)}</div>
        )
    }

    const getQtyBody = (row) => {
        const relatedStocDoc = stocDocs?.find(eachStocDoc => eachStocDoc?.docNo == row?.docNo && eachStocDoc?.materialId === row?.materialId)

        let docQty = relatedStocDoc?.docQty ? round(relatedStocDoc?.docQty) : 0
        let invoicedQty = relatedStocDoc?.invoicedQty ? round(relatedStocDoc?.invoicedQty) : 0
        let pendingQty = relatedStocDoc?.pendingQty ? round(relatedStocDoc?.pendingQty) : 0
        let inProcessQty = relatedStocDoc?.inProcessQty ? round(relatedStocDoc?.inProcessQty) : 0
        let invoicePendingQty = relatedStocDoc?.invoicePendingQty ? round(relatedStocDoc?.invoicePendingQty) : 0
        let adjustedQty = relatedStocDoc?.adjustedQty ? round(relatedStocDoc?.adjustedQty) : 0
        let convertedQty = relatedStocDoc?.convertedQty ? round(relatedStocDoc?.convertedQty) : 0
        let CNDNQty = relatedStocDoc?.CNDNQty ? round(relatedStocDoc.CNDNQty) : 0

        let piPunched = round(invoicePendingQty + inProcessQty)
        let toPunchQty = round(docQty - invoicePendingQty - invoicedQty - pendingQty - inProcessQty - convertedQty + adjustedQty + CNDNQty)

        return (
            <div>
                {invoicedQty} - {piPunched} - {pendingQty} - {toPunchQty}
            </div>
        )
    }

    const handleHeaderExpand = () => {
        let totalExpandedRows = 0
        buyerPOData?.map(eachBuyerPO => {
            let relatedBuyerPO = expandedBuyerPORows?.[`${eachBuyerPO?.buyerPOId}`]
            if (relatedBuyerPO) {
                totalExpandedRows += 1
            }

        })
        if (totalExpandedRows === 0) {
            let expandedRows = {};

            buyerPOData.forEach((row) => {
                let relatedRow = expandedBuyerPORows?.[`${row.buyerPOId}`]
                if (!relatedRow) {
                    expandedRows[`${row.buyerPOId}`] = true
                } else {
                    expandedRows = null
                }
            })
            setExpandedBuyerPORows(expandedRows)
        } else {
            setExpandedBuyerPORows(null)
        }
        // setExpandedBuyerPORows(expandedRows);
    }

    const header = () => {
        let totalExpandedRows = 0
        buyerPOData?.map(eachBuyerPO => {
            let relatedBuyerPO = expandedBuyerPORows?.[`${eachBuyerPO.buyerPOId}`]
            if (relatedBuyerPO) {
                totalExpandedRows += 1
            }

        })
        return (
            <Button icon={totalExpandedRows > 0 ? "pi pi-angle-down" : "pi pi-angle-right"} style={{ color: "grey", fontSize: "80" }} text onClick={() => handleHeaderExpand()} />
        )
    }

    const toolTipBody = (row, messageArr) => {
        return (

            <>
                {
                    messageArr?.map(eachMessage => {
                        return (
                            <p className='m-0'>{eachMessage}</p>
                        )
                    })
                }
            </>

        )
    }

    const handleViewNotesClick = (typeId, buyerInvoiceId) => {
        const relatedAdjustmentNotes = adjustmentNotes?.filter(eachAdjustmentNote => eachAdjustmentNote?.buyerInvoiceId === buyerInvoiceId && eachAdjustmentNote?.adjustmentTypeId === typeId)
        const relatedBuyerInvoiceItems = buyerInvoiceItems?.filter(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerInvoiceId === buyerInvoiceId)
        setVisibleViewAdjustmentNote(true)
        setSelectedAdjustmentNotes(relatedAdjustmentNotes)
        setSelectedBuyerInvoiceItems(relatedBuyerInvoiceItems)
    }

    const rowExpansionTemplate = (data) => {
        let relatedBuyerInvoices = []
        const updatedBuyerPOItems = data?.buyerPOItems?.map(eachBuyerPOItem => {
            let relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachBuyerPOItem?.materialId)
            const relatedDispatchNoteItems = dispatchNoteItems?.filter(eachDispatchNoteItem => eachDispatchNoteItem?.buyerPOItemId === eachBuyerPOItem?.buyerPOItemId)
            let relatedDispatchNotes = []
            let totalDispatchedQty = 0
            relatedDispatchNoteItems?.map(eachDispatchNoteItem => {
                const relatedDispatchNote = dispatchNotes?.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachDispatchNoteItem?.dispatchNoteId)
                if (relatedDispatchNote?.dispatchNoteId) {
                    relatedDispatchNotes.push(relatedDispatchNote)
                }
                totalDispatchedQty += eachDispatchNoteItem?.qty
            })
            let relatedInvoiceDispatchMap = []
            relatedDispatchNotes?.map(eachDispatchNote => {
                const relatedInvoiceDispatch = invoiceDispatchMap?.filter(eachInvoiceDispatchMap => eachInvoiceDispatchMap?.dispatchNoteId === eachDispatchNote?.dispatchNoteId)
                if (relatedInvoiceDispatch?.length > 0) {
                    relatedInvoiceDispatchMap = [...relatedInvoiceDispatchMap, ...relatedInvoiceDispatch]
                }
            })

            let totalInvoicedQty = 0
            relatedInvoiceDispatchMap?.map(eachInvoiceDispatchMap => {
                const relatedBuyerInvoice = buyerInvoices?.find(eachBuyerInvoice => eachBuyerInvoice?.buyerInvoiceId === eachInvoiceDispatchMap?.buyerInvoiceId)
                if (relatedBuyerInvoice?.buyerInvoiceId) {
                    relatedBuyerInvoices.push(relatedBuyerInvoice)
                }
                let relatedBuyerInvoiceItems = buyerInvoiceItems?.filter(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerReqItemId === eachBuyerPOItem?.buyerReqItemId)

                relatedBuyerInvoiceItems?.map(eachBuyerInvoiceItem => {
                    totalInvoicedQty += parseFloat(eachBuyerInvoiceItem?.qty)
                })
            })

            return {
                ...eachBuyerPOItem,
                ...relatedMaterial,
                totalInvoicedQty: totalInvoicedQty,
                totalDispatchedQty: totalDispatchedQty,
                pendingQty: parseFloat(eachBuyerPOItem?.bPOQty) - parseFloat(totalDispatchedQty)
            }
        })

        relatedBuyerInvoices = _.uniqBy(relatedBuyerInvoices, "buyerInvoiceId")
        relatedBuyerInvoices = _.sortBy(relatedBuyerInvoices, "buyerInvoiceId")

        const getBuyerUnitPrice = (row) => {
            return numberConversion(row.bPOUnitPrice, numberLocale)
        }

        return (
            <div className="p-2 ml-8">
            <div className="row-expansion-container">
                <div className='flex flex-row' style={{ width: "100%" }} >
                    <div className='flex flex-row' style={{ width: "80%" }} >
                        <div style={{ width: "0.4%", backgroundColor:"#ced4da"}}></div>
                        <div className='open-po-subtable' style={{ width: "99.6%"}}>
                            <DataTable value={updatedBuyerPOItems} scrollHeight="">
                                <Column field="" header="Material Id" body={getMaterialIdBody} style={{ width: "10%"}}></Column>
                                <Column field="companyProdName" header="Product Name" body={getProductNameBody} style={{ width: "15%"}}></Column>
                                <Column field="companyProdSpec" header="Product Specification" body={getProductSpecificationBody} style={{ width: "25%"}}></Column>
                                <Column field="bPOUnitPrice" body={getBuyerUnitPrice} header="Unit price" style={{ width: "8%"}}></Column>
                                <Column field='bPOQty' header="Inv-piPnch-slrOp-toPnch" headerTooltip='Invoiced - piPunched - SellerOpen - toPunch' headerTooltipOptions={{position: "top", autoHide: true}} body={getQtyBody} style={{ width: "15%"}}></Column>
                                <Column field="" header="Seller PO" body={getSellerPODocNoBody} style={{ width: "10%"}}></Column>
                            </DataTable>
                        </div>
                        </div>
                        <div className='p-card pt-2 pb-0 mb-0 col-2 ml-2' style={{ width: "20%", minHeight: "5rem", border: "1px solid #ced4da", borderRadius: "0px" }}>
                            <h3 className='mb-2 text-center mb-2'>Invoice</h3>
                            {
                                relatedBuyerInvoices?.map(eachBuyerInvoice => {
                                    const relatedBuyerInvoiceItems = buyerInvoiceItems?.filter(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerInvoiceId === eachBuyerInvoice?.buyerInvoiceId)
                                    let relatedEWayBill = eWayBills?.find(eachEWayBill => eachEWayBill?.buyerInvoiceId === eachBuyerInvoice?.buyerInvoiceId)
                                    const relatedCreditNotes = adjustmentNotes?.filter(eachCreditNote => eachCreditNote?.buyerInvoiceId === eachBuyerInvoice?.buyerInvoiceId && eachCreditNote?.adjustmentTypeId === 1)
                                    const relatedDebitNotes = adjustmentNotes?.filter(eachDebitNote => eachDebitNote?.buyerInvoiceId === eachBuyerInvoice?.buyerInvoiceId && eachDebitNote?.adjustmentTypeId === 2)
                                    let tooltipMessageArr = []
                                    relatedBuyerInvoiceItems?.map(eachBuyerInvoiceItem => {
                                        const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachBuyerInvoiceItem?.materialId)
                                        tooltipMessageArr.push(`${relatedMaterial?.companyProdName ? relatedMaterial?.companyProdName : relatedMaterial?.productName} | ${relatedMaterial?.companyProdSpec ? relatedMaterial?.companyProdSpec : relatedMaterial?.productSpecification} | Quantity : ${eachBuyerInvoiceItem?.qty}`)
                                    })
                                    let toolTipMessage = toolTipBody(eachBuyerInvoice, tooltipMessageArr)
                                    let buyerPONumbers = eachBuyerInvoice?.buyerPONumbers?.join(" & ")
                                    return (
                                        <>
                                            <Tooltip target={`.custom-tool-tip-${eachBuyerInvoice?.buyerInvoiceId}`} position='top' autoHide>
                                                {toolTipMessage}
                                            </Tooltip>
                                            <div className={`custom-tool-tip-${eachBuyerInvoice?.buyerInvoiceId} invoice-doc-no`} >
                                                <div className='flex flex-row justify-content-center align-items-center'>
                                                    {
                                                        relatedCreditNotes?.length > 0 && <div className='mr-2'><Button className="flex flex-row justify-content-center align-items-center text-xs" label="CN" rounded style={{ width: "28px", height: "28px" }} onClick={() => handleViewNotesClick(1, eachBuyerInvoice?.buyerInvoiceId)} /></div>
                                                    }
                                                    {
                                                        relatedDebitNotes?.length > 0 && <Button className="flex flex-row justify-content-center align-items-center text-xs" label="DN" rounded style={{ width: "28px", height: "28px", marginRight: "" }} onClick={() => handleViewNotesClick(2, eachBuyerInvoice?.buyerInvoiceId)} />
                                                    }
                                                </div>
                                                <Link to={`/buyerInvoice/${eachBuyerInvoice?.buyerInvoiceId}`} target='_blank' style={{ textDecoration: "none" }} >
                                                    <div style={{ textDecoration: eachBuyerInvoice.statusId === 6 ? "line-through" : "none" }}>
                                                        {eachBuyerInvoice?.docNo ? eachBuyerInvoice?.docNo : "Preview"}
                                                    </div>
                                                </Link>
                                                <div className=''><span className='font-bold'>PO No : </span><span>{buyerPONumbers}</span></div>
                                                {relatedEWayBill?.ewayBillNo ? <div className=''><span className='font-bold'>E-way : </span><span>{relatedEWayBill?.ewayBillNo}</span></div> : ""}
                                                <div className=''><span className='font-bold'>Total Amount: </span><span>{numberConversion(parseFloat(eachBuyerInvoice?.totalInvAmount), numberLocale)}</span></div>
                                            </div>
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const allowExpansion = (rowData) => {
        return rowData?.buyerPOItems?.length > 0;
    }

    const handlePageChange = async (e) => {
        let buyerPOParams = {
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            ...searchParams
        }
        if (buyerPOParams.searchBy !== "all") {
            buyerPOParams[buyerPOParams.searchBy] = buyerPOParams.searchText.trim()
        }
        dispatch(fetchBuyerPOs({ ...buyerPOParams }))
    }

    const buyerInvoiceIdLinks = previewBuyerInvoicesIds.map((buyerInvoiceId, index) => (
        <a
            key={index}
            href={`/buyerInvoice/${buyerInvoiceId}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            {index !== 0 && ", "}
            {buyerInvoiceId}
        </a>
    ))

    const message = (
        <p>
            Please cancel before proceeding.
            <br />
            Link: {buyerInvoiceIdLinks}
            <br />
            Please refresh after cancellation.
        </p>
    )

    const footer = (
        <div style={{ display: 'none' }}></div>
    )
    
    console.log("buyerPOData", buyerPOData)

    const actionButtons = [
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event),
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
    ]

    return (
        <div className="openpo-layout flex flex-column">
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">OPEN PURCHASE ORDER</h4>
                <div className="flex gap-2 justify-content-end mb-2">
                    {/* <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                    <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                    <Button icon="pi pi-filter" className={`h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                    <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>
            <div className='flex flex-row'>
                <div className="open-po-table" style={{ order: "1", width: isSearchVisible && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'"}}>
                    <div className='p-card mb-0' >
                        <div className="flex-grow-1 " >
                            <DataTable
                                value={buyerPOData}
                                expandedRows={expandedBuyerPORows}
                                onRowToggle={(e) => setExpandedBuyerPORows(e.data)}
                                rowExpansionTemplate={rowExpansionTemplate}
                                lazy
                                paginator
                                totalRecords={paginationParams?.totalRecords}
                                rows={paginationParams?.recordsPerPage}
                                page={paginationParams.pageNo}
                                onPage={e => handlePageChange(e)}
                                rowsPerPageOptions={[10, 20, 50]}
                                first={paginationParams.pageNo * paginationParams.recordsPerPage}
                                scrollable
                                scrollHeight="560px"
                                loading={isPageLoading}
                                dataKey='buyerPOId'
                            >
                                <Column expander={allowExpansion} header={header} style={{ width: '1rem' }} />
                                <Column field="" header={getHeaderCheckbox} body={getBodyCheckbox} />
                                <Column field="" header="Buyer PO" body={getDocNoBody} style={{ minWidth: "150px"}} />
                                <Column header="KAM Name" body={getKAMBody} style={{ minWidth: "150px"}} />
                                <Column field="" header="Company Name" body={getCompanyBody} style={{ minWidth: "200px"}}/>
                                <Column field="" header="PO Client Id" headerClassName='text-center' body={getPONumberBody}/>
                                <Column field="" header="Status" headerClassName='text-center' body={getStatusBody}/>
                            </DataTable>
                        </div>
                    </div>
                </div>

                {
                    isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Search setSelectedBuyerPOs={setSelectedBuyerPOs} />
                    </div>
                }

                {
                    isSearchVisible && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                            <Search setSelectedBuyerPOs={setSelectedBuyerPOs} />
                        </Sidebar>
                    </div>
                }
            </div>
            <Dialog header="Create Invoice" className='pi-punch-dialog' visible={isCreateInvoiceModalVisible} style={{ width: '85vw', minHeight: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setIsCreateInvoiceModalVisible(false)}>
                <CreateInvoice
                    selectedBuyerPODispatchNotes={selectedBuyerPODispatchNotes}
                    dispatchNoteItems={dispatchNoteItems}
                    buyerCompanyBillAddrs={buyerCompanyBillAddrs}
                    buyerCompanyBranchShipAddrs={buyerCompanyBranchShipAddrs}
                    buyerCompanyPMBillAddrs={buyerCompanyPMBillAddrs}
                    userId={userId}
                    selectedBuyerPOs={selectedBuyerPOs}
                    setIsCreateInvoiceModalVisible={setIsCreateInvoiceModalVisible}
                    handleDeleteDispatchNote={handleDeleteDispatchNote}
                    statesList={statesList}
                    companySupplyTypes={companySupplyTypes}
                />
            </Dialog>
            <Dialog header="PO Force Close" className='pi-punch-dialog' visible={isForceCloseModalVisible} style={{ width: '90vw', minHeight: '80vh', backgroundColor: '#f8f8f8' }} onHide={() => setIsForceCloseModalVisible(false)}>
                <ForceClose
                    buyerPOs={selectedBuyerPOs}
                    buyerPOItems={selectedForceClosingBuyerPOItems}
                    deliveryChallans={deliveryChallans}
                    dispatchNotes={dispatchNotes}
                    dispatchNoteItems={dispatchNoteItems}
                    materialDetails={materialDetails}
                    materialBrands={materialBrands}
                    stocDocs={stocDocs}
                    fetchBuyerPOs={fetchBuyerPOs}
                    setIsForceCloseModalVisible={setIsForceCloseModalVisible}
                />
            </Dialog>
            <Dialog header="Create Delivery Challan" className='pi-punch-dialog' visible={isCreateDeliveryChallanModalVisible} style={{ width: '85vw', minHeight: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setIsCreateDeliveryChallanModalVisible(false)}>
                <CreateDeliveryChallan
                    selectedBuyerPODispatchNotes={selectedBuyerPODispatchNotes}
                    dispatchNoteItems={dispatchNoteItems}
                    userId={userId}
                    buyerCompanyBillAddrs={buyerCompanyBillAddrs}
                    buyerCompanyBranchShipAddrs={buyerCompanyBranchShipAddrs}
                    buyerCompanyPMBillAddrs={buyerCompanyPMBillAddrs}
                    selectedBuyerPOs={selectedBuyerPOs}
                    setIsCreateDeliveryChallanModalVisible={setIsCreateDeliveryChallanModalVisible}
                    statesList={statesList}
                />
            </Dialog>
            <Dialog header="Update Tracking Details And POD" className='pi-punch-dialog' visible={isCreateUpdateTrackingPODModalVisible} style={{ width: '85vw', minHeight: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setIsCreateUpdateTrackingPODModalVisible(false)}>
                <UpdateTrackingDetailsAndPOD
                    selectedBuyerPODispatchNotes={selectedBuyerPODispatchNotes}
                    dispatchNoteItems={dispatchNoteItems}
                    buyerInvoices={buyerInvoices}
                    invoiceDispatchMap={invoiceDispatchMap}
                    userId={userId}
                    buyerCompanyBillAddrs={buyerCompanyBillAddrs}
                    buyerCompanyBranchShipAddrs={buyerCompanyBranchShipAddrs}
                    buyerCompanyPMBillAddrs={buyerCompanyPMBillAddrs}
                    selectedBuyerPOs={selectedBuyerPOs}
                    setIsCreateUpdateTrackingPODModalVisible={setIsCreateUpdateTrackingPODModalVisible}
                    statesList={statesList}
                    handleDeleteDispatchNote={handleDeleteDispatchNote}
                />
            </Dialog>
            <ViewAdjustmentNote
                type="Credit Note"
                adjustmentNote={selectedAdjustmentNotes}
                // adjustmentNoteItems={adjustmentNoteItems} 
                materialDetails={materialDetails}
                buyerInvoiceItems={selectedBuyerInvoiceItems}
                visibleViewAdjustmentNote={visibleViewAdjustmentNote}
                setVisibleViewAdjustmentNote={setVisibleViewAdjustmentNote}
            />
            <ConfirmDialog
                visible={isConfirmPreviewDialogVisible}
                onHide={() => {
                    setIsConfirmPreviewDialogVisible(false)
                    setPreviewBuyerInvoicesIds([])
                }}
                message={message} /*"Active Preview exist, please cancel that before creating another DN?"*/
                header="Active Preview Clash"
                icon="pi pi-exclamation-triangle"
                rejectLabel={""}
                acceptLabel={""}
                reject={() => {
                    setIsConfirmPreviewDialogVisible(false)
                    setPreviewBuyerInvoicesIds([])
                }}
                accept={() => {
                    setIsConfirmPreviewDialogVisible(false)
                    setPreviewBuyerInvoicesIds([])
                }}
                footer={footer}
            />
            <Loading visible={isLoading} />
        </div>
    )
}

export default OpenPO